// extracted by mini-css-extract-plugin
export default {"root":"More_root__w-w5l","movein":"More_movein__3A8QY"};